export type Environment = {
  id: string;
  label: string;
  baseUrl: string;
  preset: boolean;
};

export const PRESET_ENVIRONMENTS: Environment[] = [
  { id: "prod",     label: "Production",      baseUrl: "https://hpac-uk.org",         preset: true },
  { id: "staging",  label: "Staging",         baseUrl: "https://staging.hpac-uk.org", preset: true },
  { id: "local",    label: "Local Rails :3000", baseUrl: "http://localhost:3000",     preset: true },
];

export type CompletionStatus = "complete" | "expired" | "missing" | "awaiting_review" | string;

export type CertTypeScope = "org" | "hpac_baseline";

export type StatutoryCompletion = {
  cert_type_slug: string;
  cert_type_name: string;
  category?: string | null;
  statutory_type: string;
  scope: CertTypeScope;
  status: CompletionStatus;
  acquired_on: string | null;
  expires_on: string | null;
  evidence_file_id: number | null;
  files: string[];
};

export type Address = {
  line_1: string | null;
  line_2: string | null;
  line_3: string | null;
  city: string | null;
  county: string | null;
  postcode: string | null;
  country: string | null;
};

// Basic profile block — only returned by the API when the key has
// `profile.read` granted. Contains nothing more than the API explicitly
// exposes (no password, declarations, DBS, payment or internal fields).
export type Profile = {
  salutation: string | null;
  first_name: string;
  last_name: string;
  email: string;
  contact_number: string | null;
  date_of_birth: string | null;
  address: Address;
};

export type Registrant = {
  pin: string;
  approved: boolean;
  // These four are gated by `profile.read` — absent when the permission is
  // not granted. Kept as the legacy top-level shape for back-compat.
  first_name?: string;
  last_name?: string;
  email?: string;
  date_of_birth?: string | null;
  // Full basic-profile block — only when `profile.read` is granted.
  profile?: Profile;
  grade: string | null;
  sponsored: boolean;
  sponsorship_pending: boolean;
  // Absent when the key has no S&M read permission at all.
  statutory_completions?: StatutoryCompletion[];
};

// `GET /api/v1/primary_evidence/:id` and items in
// `GET /api/v1/registrants/:pin/primary_evidence`.
export type PrimaryEvidenceFile = {
  id: number;
  registrant_pin: string | null;
  evidence_type: string | null;
  name: string | null;
  acquired_on: string | null;
  expires_on: string | null;
  status: string;
  scope: "own" | "others";
  authored_via_api: boolean;
  files: string[];
  created_at: string | null;
  updated_at: string | null;
};

export type CertType = {
  slug: string;
  name: string;
  category: string | null;
  statutory_type: string;
  recertification_frequency: number | null;
  required_for_grades: string[];
  scope: CertTypeScope;
};

export type ApiLogEntry = {
  id: string;
  at: number;
  method: string;
  url: string;
  status: number | null;
  durationMs: number | null;
  requestBody: string | null;
  responseBody: string | null;
  error?: string;
  requestHeaders: Record<string, string>;
  // When set the request body was multipart and we don't echo it raw
  multipartSummary?: string;
};
